import Grid from '@mui/material/Grid';
import { CajasProvider } from "src/context/CajasContext/CajasContext";
import { DigitalizacionesList } from "../components/Digitalizaciones/DigitalizacionesList";
import { EstadisticasDigitalizaciones } from "../components/Digitalizaciones/EstadisticasDigitalizaciones";
import { PageHeaderCard } from 'src/general_components/PageHeaderCard';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';

export function Digitalizaciones() {
  return (
    <Grid style={{ marginBottom: "50px", paddingTop: 10 }}>
      <PageHeaderCard title="Digitalizaciones" icon={<DocumentScannerIcon />} />
      <Grid sx={{ px: 1, mb: 2 }}>
        <EstadisticasDigitalizaciones />
      </Grid>
      <CajasProvider>
        <Grid>
          <DigitalizacionesList />
        </Grid>
      </CajasProvider>
    </Grid>
  );
}
